import React from 'react'
import { PatientHistoryType } from 'src/graphql.generated'
import ScoreQuestionnaireFields from './ScoreQuestionnaireFields'

const WHO5_QUESTIONS = [
  'I have felt cheerful and in good spirits.',
  'I have felt calm and relaxed.',
  'I have felt active and vigorous.',
  'I woke up feeling fresh and rested.',
  'My daily life has been filled with things that interest me.',
]

const WHO5Fields = ({ uid }: { uid: string }) => (
  <ScoreQuestionnaireFields
    uid={uid}
    type={PatientHistoryType.Who5}
    title="WHO-5"
    prefix="WHO5"
    questions={WHO5_QUESTIONS}
    max={5}
  />
)

export default WHO5Fields
